import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Header, Icon } from 'semantic-ui-react';
import { notificationsUrl } from '@/constants/urls';
import { notificationsIcon } from '../constants';

const NotificationsPanelHeader = ({
  category,
  className,
  code,
  isLoading,
  value,
}) => {
  const intl = useIntl();
  if (!value) {
    return null;
  }

  const icon = isLoading ? 'circle notch' : notificationsIcon(category);
  return (
    <Header
      as="a"
      href={notificationsUrl(category, code, '#')}
      className={clsx('aridhia-notifications-panel-header primary aridhia-h2', className)}
      rel="noopener noreferrer"
    >
      <Icon loading={isLoading} name={icon} color="blue" />
      <Header.Content content={intl.formatMessage({ id: 'tabs.notifications.on' }, { name: value })} />
    </Header>
  );
};

export default NotificationsPanelHeader;
